import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ResourceColumn, ResourceListPage } from '../../components/resource/ResourceListPage';
import { DefeitoPallet } from '../../types/qualidade';
import { defeitosService } from '../../services';

const columns: ResourceColumn<DefeitoPallet>[] = [
  { header: 'Código', accessor: 'codigo' },
  { header: 'Descrição', accessor: 'descricao' },
  { header: 'Severidade', accessor: 'severidade' },
];

export const DefeitosListPage: React.FC = () => {
  const navigate = useNavigate();

  return (
  <ResourceListPage
    title="Defeitos"
    description="Registro de defeitos encontrados."
    columns={columns}
    service={defeitosService}
    createPath="/admin/qualidade/defeitos/novo"
      onEdit={(item) => item.id && navigate("/admin/qualidade/defeitos/editar", { state: { record: item } })}
  />
  );
};